import ServiceRegister from'./ServiceRegister';export default ServiceRegister;